import { render, staticRenderFns } from "./GasPrice.vue?vue&type=template&id=44522e0a&scoped=true"
import script from "./GasPrice.vue?vue&type=script&lang=js"
export * from "./GasPrice.vue?vue&type=script&lang=js"
import style0 from "./GasPrice.vue?vue&type=style&index=0&id=44522e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44522e0a",
  null
  
)

export default component.exports